import { render } from "./EditAbonnementView.vue?vue&type=template&id=28153968"
import script from "./EditAbonnementView.vue?vue&type=script&lang=js"
export * from "./EditAbonnementView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__